const buttons = {
	add: "Voeg toe",
	add_qemu: "Voeg VPS toe",
	block: "Blokkeren",
	calculate: "Doorrekenen",
	cancel: "Annuleren",
	change_template: "Wijzig template",
	check: "Controleren",
	choose: "Configureer",
	close: "Sluiten",
	confirm: "Bevestigen",
	connect: "Koppel",
	copied: "Gekopieerd!",
	copy: "Kopiëren",
	create: "Aanmaken",
	deblock: "Deblokkeren",
	delete: "Verwijderen",
	details: "Details",
	disconnect: "Ontkoppelen",
	edit: "Wijzigen",
	get_details: "Details ophalen",
	leave: "Verlaten",
	more: "Meer",
	more_info: "Meer informatie",
	next: "Volgende",
	order: "Bestellen",
	previous: "Vorige",
	resend: "Opnieuw versturen",
	reset: "Reset",
	save: "Opslaan",
	search: "Zoeken",
	select: "Selecteren",
	selected: "Geselecteerd",
	send: "Versturen",
	show_details: "Toon details",
	sign_in: "Inloggen",
	sign_in_return: "Naar login pagina",
	sign_up: "Registreren",
	start_tour: "Start tour",
	update: "Wijzig",
	view: "Bekijken",
};

export default buttons;
